import { useCallback, useMemo } from 'react';
import { useMutation } from 'data-fetching-client';
import { default as FormattedHTMLMessage, default as FormattedMessage } from 'I18n/components/FormattedHTMLMessage';
import { ReportActionsFloatingAlertStore } from 'reporting-action-components/shared/ReportActionsFloatingAlertStore';
// @ts-expect-error Untyped import
import { getBusinessUnitId } from '../../data/schemas/reportSchema';
// @ts-expect-error Untyped import
import { SET_DASHBOARD_BUSINESS_UNIT } from '../../data/requests/dashboards';
// @ts-expect-error Untyped import
import { useHideDialog } from '../../dialog/ducks';
import { EVENTS } from '../../utils/usageTracker';
import SetAssetBusinessUnitModal from '../shared/setBusinessUnit/SetAssetBusinessUnitModal';
import { jsx as _jsx } from "react/jsx-runtime";
const SingleAssetStatusKeys = {
  successKey: 'reporting-action-components.actions.setBusinessUnit.alert.dashboard.success.single',
  failureKey: 'reporting-action-components.actions.setBusinessUnit.alert.dashboard.failure.single'
};
const MultiAssetStatusKeys = {
  successKey: 'reporting-action-components.actions.setBusinessUnit.alert.dashboard.success.multi',
  failureKey: 'reporting-action-components.actions.setBusinessUnit.alert.dashboard.failure.multi'
};
const SetDashboardBusinessUnitModal = ({
  assets: dashboards,
  assetCount,
  filters,
  onSetBusinessUnitSuccess = () => {},
  usageTracker
}) => {
  const closeDialog = useHideDialog();
  const [setBusinessUnitMutation] = useMutation(SET_DASHBOARD_BUSINESS_UNIT);
  const isMulti = assetCount > 1;
  const handleSave = useCallback(businessUnit => {
    const {
      successKey,
      failureKey
    } = isMulti ? MultiAssetStatusKeys : SingleAssetStatusKeys;
    const firstDashboard = dashboards[0];
    setBusinessUnitMutation({
      variables: {
        dashboardIds: dashboards.map(dashboard => dashboard.get('id')),
        businessUnitId: businessUnit,
        filters
      }
    }).then(() => {
      if (usageTracker) {
        usageTracker.track(EVENTS.completeAssetUpdate, {
          action: 'set-business-unit',
          actionType: 'save',
          assetType: 'dashboard',
          count: assetCount,
          object: 'business-unit'
        });
      }
      ReportActionsFloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: successKey,
          options: {
            assetName: firstDashboard === null || firstDashboard === void 0 ? void 0 : firstDashboard.get('name')
          }
        }),
        type: 'success'
      });
      const updatedFirstDashboard = firstDashboard && firstDashboard.set('businessUnitId', businessUnit);
      onSetBusinessUnitSuccess(updatedFirstDashboard);
    }, () => {
      ReportActionsFloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: failureKey
        }),
        type: 'danger'
      });
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    }).finally(() => {
      closeDialog();
    });
  }, [assetCount, closeDialog, filters, isMulti, dashboards, usageTracker, onSetBusinessUnitSuccess, setBusinessUnitMutation]);
  const AssetCountLabel = useMemo(() => isMulti ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reporting-action-components.actions.setBusinessUnit.dialog.selectedAssetCount.dashboard",
    options: {
      assetCount
    }
  }) : undefined, [assetCount, isMulti]);
  return /*#__PURE__*/_jsx(SetAssetBusinessUnitModal, {
    AssetCountLabel: AssetCountLabel,
    descriptionKey: 'reporting-action-components.actions.setBusinessUnit.dialog.description.dashboard_buv2',
    initialValue: getBusinessUnitId(dashboards[0]),
    onSave: handleSave
  });
};
export default SetDashboardBusinessUnitModal;